import PageHeader from "../components/PageHeader";
import { Card } from "../components/ui";

export default function Placeholder({ title, subtitle, icon: Icon }) {
  return (
    <div>
      <PageHeader title={title} subtitle={subtitle} />
      <Card className="flex flex-col items-center justify-center gap-3 p-16 text-center">
        {Icon && (
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-surface-container-low text-on-surface-variant">
            <Icon size={22} />
          </div>
        )}
        <p className="text-body-md font-medium text-on-surface">Coming soon</p>
        <p className="max-w-sm text-body-sm text-on-surface-variant">
          This area is being built out. Check back shortly.
        </p>
      </Card>
    </div>
  );
}
